import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    mappings: [],
    busy: false,
  },
  modules: {},
  mutations: {
    set(state, data) {
      state.mappings = data.mappings
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    selectedResrakuTableIds(state) {
      const resrakuTables = state.mappings.map(val => val.resrakuTables)
      const ids = resrakuTables?.reduce((accum, current) => {
        return [...current.map(v => v?.id), ...accum]
      }, [])
      return ids
    },
  },
  actions: {
    async get({ commit }) {
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/sync_resraku/list')
      if (status === 200) {
        commit('set', data)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
